module.exports = __webpack_public_path__ + "media/app/assets/twitch-background-cc1d1642d6a532c25e44de934ce693b9.png";